// extracted by mini-css-extract-plugin
export default {"Container":"Federal_Container__NVa0U","section-1":"Federal_section-1__VAsaW","content":"Federal_content__0FmPQ","ul":"Federal_ul__gyvdw","section-2":"Federal_section-2__joS0E"};